export const LONG_OPTIONS = [
	{ value: '1', label: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam' },
	{ value: '2', label: 'Lorem ipsum dolor' },
	{
		value: '3',
		label:
			'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
	},
	{ value: '4', label: 'Lorem ipsum dolor' },
	{ value: '5', label: 'Lorem ipsum dolor' },
	{ value: '6', label: 'Lorem ipsum dolor' },
	{ value: '7', label: 'Lorem ipsum dolor' },
	{ value: '8', label: 'Lorem ipsum dolor' },
	{ value: '2', label: 'Lorem ipsum dolor' },
];
